import { FC } from 'react';
import PermissionDeniedPage from './PermissionDeniedPage';

const PagePermissionDeniedPage: FC = () => (
  <PermissionDeniedPage
    title="Kein Zugriff auf diese Seite"
    description="Du hast aktuell nicht die notwendige Berechtigung, um diese Seite zu sehen. Bitte wende Dich an Deine Managerin oder Deinen Manager, wenn Du Zugriff benötigst."
    buttonLabel="Zurück zu den Events"
  />
);

export default PagePermissionDeniedPage;
